import React from 'react'
import { connect } from 'react-redux'
import { Row, Col, Grid, Panel, PanelBody, PanelContainer } from '@sketchpixy/rubix'

import backgroundImage from '../../images/background.jpg'

const backgroundCss = {
  background: `url(${backgroundImage})`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundColor: '#E0E0E0',
  backgroundRepeat: 'no-repeat',
}

const colProps = {
  sm: 4,
  md: 6,
  smOffset: 4,
  mdOffset: 3,
  xs: 10,
  xsOffset: 1,
  collapseLeft: true,
  collapseRight: true,
}

const Signup = props => {
  const userTypeFarsi = props.signUpUserType

  return (
    <div className="signup ltr" style={backgroundCss}>
      <div id="auth-row">
        <div id="auth-cell">
          <Grid>
            <Row className="signup-container">
              <Col {...colProps}>
                <PanelContainer controls={false} id="login-panel">
                  <Panel>
                    <PanelBody style={{ padding: 0 }}>
                      <div
                        className="text-center bg-darkblue fg-white"
                        style={{ padding: 10 }}
                      >
                        <h3 style={{ margin: 0, padding: 10 }}>سامانه مبنا</h3>

                        {userTypeFarsi && <h4>{`عضویت ${userTypeFarsi}`}</h4>}
                      </div>

                      {React.cloneElement(props.children, {
                        ...props,
                        key: props.pathname,
                      })}
                    </PanelBody>
                  </Panel>
                </PanelContainer>
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    </div>
  )
}

const figureOutUserTypeFromUrl = pathname => {
  if (/student/.test(pathname)) {
    return 'دانش آموز'
  }
  if (/school/.test(pathname)) {
    return 'مرکز آموزشی'
  }
  if (/teacher/.test(pathname)) {
    return 'معلم'
  }
  return ''
}

function mapStateToProps(state) {
  const { pathname } = state.routing.locationBeforeTransitions

  return { signUpUserType: figureOutUserTypeFromUrl(pathname), pathname }
}

export default connect(mapStateToProps)(Signup)



// WEBPACK FOOTER //
// ./src/components/authentication/Signup.js